module.exports = __webpack_public_path__ + "img/header-weddingRingsPalladium@2x.df05190.jpg";